<style lang="scss" scoped>
@include component(empty) {
	padding: 50px;
	text-align: center;
	border: 2px dashed #eee;
	border-radius: 10px;
	margin: 40px;
	@include part(text) {
		font-size: 21px;
		font-weight: 600;
	}
	@include part(icon) {
		display: block;
		margin-bottom: 20px;
		font-size: 40px;
		color: darken(#eee, 14);
		font-weight: normal;
	}
}
</style>

<template>
	<div class="empty">
		<i class="empty__icon fe fe-alert-circle"></i>
		<div class="empty__text">{{ message }}</div>
		<slot name="content"></slot>
	</div>
</template>
<script>
export default {
	props: {
		message: {
			type: String,
			default: "Nothing to see here"
		}
	}
};
</script>

